import * as React from "react";
import type { SVGProps } from "react";
const SvgTabletHorizontal = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M2.25 16.51v-9c0-1.24 1.01-2.25 2.25-2.25h15c1.24 0 2.25 1.01 2.25 2.25v9c0 1.24-1.01 2.25-2.25 2.25h-15c-1.24 0-2.25-1.01-2.25-2.25ZM5.25 10.5v3"
    />
  </svg>
);
export default SvgTabletHorizontal;
